import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';

import { withPermissions, permissions } from '../../shared/authorization';
import {
  environmentSuffixSelector,
  featureFlagsSelector,
  userSelector,
} from '../../shared/store/selectors';
import { useSelectableRowsGridLogic } from '@client-shared/agGrid/selectableRows';
import useGridApi from '../../shared/hooks/useGridApi.hook';
import { MaintenanceModeSelection } from './maintenanceModeSelection.component';
import { FeatureFlagsPropTypes } from './propTypes';
import getPermissionsFromTree from '../../shared/authorization/getPermissionsFromTree.helper';
import permissionPaths from '../../shared/authorization/permissionPaths';
import permissionTypes from '../../shared/authorization/permissionTypes';
import { displayZeroSelector, hideDecimalsSelector, negativeMinusSelector } from '../../userData/store/selectors';
import { ClientsGridSection } from './clientsGridSection.component';

export const PureClientsPage = ({
  canModify,
  featureFlags,
  user,

  environmentSuffix,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
}) => {
  const canUserModifyMultipleClients = getPermissionsFromTree(
    user.permissions, permissionPaths.CLIENT
  )[permissionTypes.MULTIPLE_CLIENT_MANAGEMENT];

  const { gridApi, onGridReady } = useGridApi();
  const selectionApi = useSelectableRowsGridLogic({
    gridApi,
    getRowUniqueId: client => client.clientId,
  });

  return (
    <div className="page">
      <ReactTooltip/>
      <ClientsGridSection
        canModify={canModify}
        featureFlags={featureFlags}
        selectionApi={selectionApi}
        onGridReady={onGridReady}
        canUserModifyMultipleClients={canUserModifyMultipleClients}
        environmentSuffix={environmentSuffix}
        shouldDisplayZero={shouldDisplayZero}
        hideDecimals={hideDecimals}
        negativeMinus={negativeMinus}
      />
      {
        canUserModifyMultipleClients && (<MaintenanceModeSelection
          selectionApi={selectionApi}
        />)
      }
    </div>
  );
};

PureClientsPage.propTypes = {
  canModify: PropTypes.bool.isRequired,

  featureFlags: FeatureFlagsPropTypes,
  user: PropTypes.shape({
    lastClientId: PropTypes.number,
    permissions: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  }),
  environmentSuffix: PropTypes.string,
  shouldDisplayZero: PropTypes.bool,
  hideDecimals: PropTypes.bool,
  negativeMinus: PropTypes.bool,
};

const mapStateToProps = state => ({
  featureFlags: featureFlagsSelector(state),
  user: userSelector(state),
  environmentSuffix: environmentSuffixSelector(state),
  shouldDisplayZero: displayZeroSelector(state),
  hideDecimals: hideDecimalsSelector(state),
  negativeMinus: negativeMinusSelector(state),
});

export default withPermissions(permissions.CLIENT)(connect(
  mapStateToProps
)(PureClientsPage));
